import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useSearchParams,
} from "react-router-dom";

import Home from "../components/Home";
import UploadImage from "../components/UploadImage";
import ImageResult from "../components/ImageResult";
import PeopleWall from "../components/PeopleWall";
import Pintura from "../components/Pintura";
import Detail from "../components/Detail";
import { doRequest } from "../helper";

export default function AppRoutes() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [searchParams] = useSearchParams();
  const userid = searchParams.get("userid");

  const login = async (userid) => {
    if (isLoggedIn) {
      return;
    }
    if (userid.split("userid=").length > 1) {
      userid = userid.split("userid=")[1];
    }
    let reqData = {
      userid: userid,
    };
    let response = await doRequest(reqData, "POST", "user/login");
    if (response?.resultFlag === 1 || response?.resultFlag === "1") {
      setIsLoggedIn(true);
      localStorage.setItem("user_details", JSON.stringify(response?.response));
    } else {
      setIsLoggedIn(false);
    }
  };

  const checkLoggedIn = () => {
    if (!isLoggedIn) {
      window.location.href = "appclick://login";
    }
  };

  useEffect(() => {
    if (userid && !isLoggedIn) {
      login(userid);
    }
  }, [userid, isLoggedIn]);
  return (
    <>
      {!userid && (
        <div
          style={{
            zIndex: "10",
            width: "100%",
            height: "100vh",
            position: "fixed",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          }}
          onClick={() => checkLoggedIn()}
        ></div>
      )}
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/uploadimage/:topic" element={<UploadImage />}></Route>
        <Route path="/imageresult" element={<ImageResult />}></Route>
        <Route path="/peoplewall" element={<PeopleWall />}></Route>
        <Route path="/pintura" element={<Pintura />}></Route>
        <Route path="/:id" element={<Detail />}></Route>
      </Routes>
    </>
  );
}
